import { cn } from '@latitude/token-utils';
import { cva } from 'class-variance-authority';

export const commandItemVariants = cva(
  cn([
    'w-full',
    'flex',
    'select-none',
    'items-center',
    'outline-none',
    'focus:outline-none',
    '[&>svg]:fill-current',
    'rounded-radius-comp-action-list-round',
    'gap-spacing-comp-action-list-medium-gap',
  ]),
  {
    variants: {
      state: {
        default: [
          'bg-color-comp-action-list-strong-container-enabled',
          'text-color-comp-action-list-strong-on-container-default',
          'hover:bg-color-comp-action-list-strong-container-hover',
          'data-[selected=true]:bg-color-comp-action-list-strong-container-hover',
          'cursor-pointer',
        ],
        selected: [
          'bg-color-comp-action-list-strong-container-selected',
          'text-color-comp-action-list-strong-on-container-selected',
          'hover:bg-color-comp-action-list-strong-container-hover',
        ],
        disabled: [
          'cursor-not-allowed',
          'bg-color-comp-action-list-strong-container-disabled',
          'text-color-comp-action-list-strong-on-container-disabled',
        ],
        separator: [
          'cursor-default',
          'bg-color-comp-action-list-strong-container-separator',
          'text-color-comp-action-list-strong-on-container-separator',
        ],
        readOnly: [
          'bg-color-comp-action-list-strong-container-enabled',
          'text-color-comp-action-list-strong-on-container-default',
        ],
      },
      size: {
        medium: [
          'text-font-comp-action-list-medium-font-size',
          'font-comp-action-list-medium-font-family',
          'font-comp-action-list-medium-font-weight',
          'leading-font-comp-action-list-medium-line-height',
          'py-spacing-comp-action-list-medium-vertical',
          'px-spacing-comp-action-list-medium-gap',
        ],
        small: [
          'text-font-comp-action-list-small-font-size',
          'font-comp-action-list-small-font-family',
          'font-comp-action-list-small-font-weight',
          'leading-font-comp-action-list-small-line-height',
          'py-spacing-comp-action-list-small-vertical',
          'px-spacing-comp-action-list-small-gap',
        ],
      },
    },
    defaultVariants: {
      size: 'medium',
      state: 'default',
    },
  },
);
